import '../styles/found.css';
import closerlook from 'url:../assets/isp/A Closer Look.png';
import backpacker from 'url:../assets/isp/Backpacker 01.png';
import bicycle from 'url:../assets/isp/Bicycle - Tandem 2.png';
import boss from 'url:../assets/isp/Boss - Steaming.png';
import campfire from 'url:../assets/isp/Campfire 24.png';
import chicken from 'url:../assets/isp/Chicken.png';
import compass from 'url:../assets/isp/Compass 5.png';
import computerd from 'url:../assets/isp/Computer - Distressed.png';
import computer29 from 'url:../assets/isp/Computer 29.png';
import computerc from 'url:../assets/isp/Computer Gone Crazy.png';
import demolition from 'url:../assets/isp/Demolition Man.png';
import desktop from 'url:../assets/isp/Desktop 002.png';
import fax from 'url:../assets/isp/Fax Attack.png';
import frame from 'url:../assets/isp/Frame 2226.png';
import grandma from 'url:../assets/isp/Grandma 6.png';
import grenade from 'url:../assets/isp/Grenade - Oops!.png';
import hiding from 'url:../assets/isp/Hiding a Bomb.png';
import horse from 'url:../assets/goldenhorse.png';
import insideout from 'url:../assets/isp/Inside-Out Umbrella.png';
import itsthisway from 'url:../assets/isp/It\'s This Way.png';
import lion from 'url:../assets/isp/Lion & Pyramids.png';
import manwithplan from 'url:../assets/isp/Man with a Plan.png';
import mousedisk from 'url:../assets/isp/Mouse & Disk.png';
import mouse13 from 'url:../assets/isp/Mouse 13.png';
import mousemouse from 'url:../assets/isp/Mouse with Mouse.png';
import oven from 'url:../assets/isp/Oven 4.png';
import pillow from 'url:../assets/isp/Pillow Smiling.png';
import playing from 'url:../assets/isp/Playing Computer.png';
import readybbq from 'url:../assets/isp/Ready to Barbeque.png';
import recycling from 'url:../assets/isp/Recycling - Wizard.png';
import rocket from 'url:../assets/isp/Rocket Chasing Man.png';
import scared from 'url:../assets/isp/Scared.png';
import skateboard from 'url:../assets/isp/Skateboarding 42.png';
import soldier from 'url:../assets/isp/Soldier with Satellite Dish.png';
import thug2 from 'url:../assets/isp/Thug 2.png';
import toxiccreature from 'url:../assets/isp/Toxic Creature 3.png';
import toxicwaste from 'url:../assets/isp/Toxic Waste 1.png';
import trash from 'url:../assets/isp/Trash Can 03.png';
import treasure from 'url:../assets/isp/Treasure Chest 2.png';
import umbrella from 'url:../assets/isp/Umbrella Parachute.png';
import warm from 'url:../assets/isp/Warm for Winter.png';
import window from 'url:../assets/window.png';
import worker from 'url:../assets/isp/Worker - Beaver.png';
import { Smashable } from '../components/cursor/Smashable';
import { useNavigate } from 'react-router';

export function ClipArtWorld() {
    const nav = useNavigate();

    return <div className='found-page'>
        <div className='found-viewport'>
            <img className='found-item' src={mousemouse} style={{top: 330, left: 1150, width: 84}} />
            <img className='found-item' src={boss} style={{top: 360, left: 1050, width: 72}} />
            <img className='found-item' src={closerlook} style={{top: 420, left: 1100, width: 72}} />
            <img className='found-item' src={backpacker} style={{top: 360, left: 700, width: 48}} />
            <img className='found-item' src={bicycle} style={{top: 380, left: 450, width: 64}} />
            <img className='found-item' src={worker} style={{top: 380, left: 540, width: 84}} />
            <img className='found-item' src={hiding} style={{top: 440, left: 570, width: 72}} />
            <img className='found-item' src={chicken} style={{top: 500, left: 520, width: 172}} />
            <img className='found-item' src={computerc} style={{top: 480, left: 1150, width: 160}} />
            <div className='found-item' style={{top: 496, left: 1190}}>
                <img src={horse} className='spinny' style={{width: 40}} onClick={() => { nav('/omgitbfghbb') }}/>
            </div>
            <img className='found-item' src={compass} style={{top: 540, left: 1150, width: 48}} />
            <Smashable><img className='found-item' src={window} style={{top: 475, left: 1125, width: 180}} /></Smashable>
            <img className='found-item' src={computerd} style={{top: 600, left: 100, width: 172}} />
            <img className='found-item' src={rocket} style={{top: 400, left: 700, width: 320}} />
            <img className='found-item' src={computer29} style={{top: 430, left: 950, width: 108}} />
            <img className='found-item' src={demolition} style={{top: 250, left: 150, width: 64}} />
            {/* <img className='found-item' src={desktop} style={{top: 250, left: 150, width: 64}} /> */}
            <img className='found-item' src={fax} style={{top: 800, left: 100, width: 280}} />
            {/* <img className='found-item' src={frame} style={{top: 800, left: 100, width: 256}} /> */}
            <img className='found-item' src={grandma} style={{top: 600, left: 700, width: 128}} />
            <img className='found-item' src={grenade} style={{top: 580, left: 1050, width: 96}} />
            {/* <img className='found-item' src={horse} style={{top: 500, left: 1240, width: 96}} /> */}
            <img className='found-item' src={insideout} style={{top: 220, left: 710, width: 128}} />
            <img className='found-item' src={playing} style={{top: 400, left: 250, width: 128}} />
            <img className='found-item' src={recycling} style={{top: 420, left: 420, width: 72}} />
            <img className='found-item' src={toxiccreature} style={{top: 460, left: 200, width: 128}} />
            <img className='found-item' src={itsthisway} style={{top: 490, left: 320, width: 196}} />
            <img className='found-item' src={lion} style={{top: 420, left: 0, width: 208}} />
            <img className='found-item' src={scared} style={{top: 420, left: 985, width: 24}} />
            <img className='found-item' src={manwithplan} style={{top: 520, left: 750, width: 340}} />
            <img className='found-item' src={campfire} style={{top: 800, left: 600, width: 220}} />
            <img className='found-item' src={mousedisk} style={{top: 650, left: 20, width: 84}} />
            <img className='found-item' src={mouse13} style={{top: 800, left: 980, width: 220}} />
            <img className='found-item' src={treasure} style={{top: 380, left: 1240, width: 48}} />
            <img className='found-item' src={oven} style={{top: 420, left: 1280, width: 128}} />
            <img className='found-item' src={pillow} style={{top: 640, left: 1140, width: 380}} />
            <img className='found-item' src={readybbq} style={{top: 500, left: 1320, width: 160}} />
            <img className='found-item' src={skateboard} style={{top: 580, left: 340, width: 320}} />
            <img className='found-item' src={soldier} style={{top: 300, left: 1400, width: 108}} />
            <img className='found-item' src={thug2} style={{top: 380, left: 150, width: 64}} />
            <img className='found-item' src={toxicwaste} style={{top: 900, left: 0, width: 119}} />
            <img className='found-item' src={trash} style={{top: 370, left: 50, width: 72}} />
            <img className='found-item' src={umbrella} style={{top: 100, left: 1100, width: 96}} />
            <img className='found-item' src={warm} style={{top: 280, left: 440, width: 32}} />
        </div>
        {/* <p>I spy a lost webpage, six mice, and a secret bomb.</p> */}
    </div>
}